import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20with%20multiple%20characters%2C%20dynamic%20composition%2C%20vibrant%20colors%20with%20warm%20orange%20and%20gold%20tones%2C%20artistic%20abstract%20background%20with%20soft%20gradients%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20clean%20visual%20style&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        alt="韩漫漫画网站 - 韩漫在线免费阅读"
        title="韩漫漫画网站 - 韩漫大全热门合集"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto text-center px-4">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            韩漫漫画网站
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 max-w-2xl mx-auto">
            汇聚众多<strong>好看韩国漫画</strong>，支持<strong>韩漫在线免费阅读</strong>
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
            <strong>韩漫大全</strong>内容涵盖各种<strong>热门合集</strong>，满足您的多元化口味
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-book-read-line"></i>
              </div>
              开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white rounded-lg text-sm font-medium backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer border border-white/20"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-heart-line"></i>
              </div>
              恋爱漫画
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}